import { DbaLogo } from '@components/dba/DbaLogo.js';
import { SolgtComLogo } from '@components/dba/SolgtComLogo.js';
import { IconCheck16 } from '@warp-ds/icons/react/check-16';
import { Box, Button } from '@warp-ds/react';
import type React from 'react';

export const SolgtComPage: React.FC = () => {
  const scrollToTop = () => {
    document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="mb-64">
      <main>
        <header id="main-header" className="mb-24">
          <Box bleed>
            <h1>Sælg din bil hurtigt og sikkert - få en garantipris!</h1>
            <div className="h4">
              DBA samarbejder med Solgt.com om at levere en nem, hurtig, sikker og uforpligtende måde at få solgt din
              bil på.
            </div>
          </Box>
        </header>
        <div className="flex flex-col md:flex-row md:gap-16 md:pl-16">
          <div className="rounded-8 h-[565] md:max-w-[343] overflow-hidden shadow-m min-w-[343] m-auto">
            <iframe
              sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
              className="border-none rounded-8 h-[565] min-w-[343]"
              title="Solgt.com vurdering"
              src="https://dba.solgt.com"
            />
          </div>
          <Box bleed className="mt-40 md:mt-0 pt-0">
            <header className="mb-24">
              <h2>Sådan fungerer Solgt.com</h2>
            </header>
            <div className="flex mb-16">
              <div className="mr-16 font-bold">1</div>
              <div>
                <span className="font-bold">Indtast nummerplade</span> og tryk på knappen{' '}
                <span className="font-bold">"Hvad er min bil værd"</span>. Udfyld dernæst kontaktoplysninger hos
                Solgt.com og tryk på <span className="font-bold">"Modtag pris"</span>.
              </div>
            </div>
            <div className="flex mb-16">
              <div className="mr-16 font-bold">2</div>
              <div>Du modtager vurderingen på SMS og Email indenfor 24 timer.</div>
            </div>
            <div className="flex mb-16">
              <div className="mr-16 font-bold">3</div>
              <div>
                Book tid hos en af vores forhandlere, som tjekker bilen efter for bl.a. ekstraudstyr, skader, defekter
                m.v. Herefter får du en Garantipris som er gældende i syv dage.
              </div>
            </div>
            <div className="flex">
              <div className="mr-16 font-bold">4</div>
              <div>
                Du kan vælge at sælge din bil eller lade den indgå i en byttehandel.{' '}
                <span className="font-bold">Tilbuddet er uforpligtende</span>.
              </div>
            </div>
            <div className="mt-24 text-detail s-text-subtle">
              *Kun personbiler på fuld afgift fra og med årgang 2000. Dvs. ingen ældre biler, nuværende og tidligere
              taxa'er, leasingbiler, varebiler eller biler uden afgift.
            </div>
            <div className="sm:hidden">
              <Button onClick={() => scrollToTop()} primary fullWidth className="mt-24">
                Få vurdering
              </Button>
            </div>
          </Box>
        </div>
      </main>
      <Box bleed>
        <hr className="md:mt-24" />
      </Box>
      <section id="about">
        <Box bleed>
          <header className="mb-24">
            <h3>Om Solgt.com</h3>
          </header>
          <div className="flex-col mb-32">
            <div className="flex cols-2 items-center mb-8">
              <IconCheck16 className="s-icon-positive mr-8" />
              Det er&nbsp;<span className="font-bold">gratis</span>
              &nbsp;og&nbsp;
              <span className="font-bold">uforpligtende</span>
            </div>
            <div className="flex cols-2 items-center mb-8">
              <IconCheck16 className="s-icon-positive mr-8" />
              Autoriserede landsækkende forhandlere
            </div>
            <div className="flex cols-2 items-center mb-8">
              <IconCheck16 className="s-icon-positive mr-8" />
              Garanteret salg og/med sikker betaling
            </div>
          </div>
          <iframe
            sandbox="allow-scripts allow-same-origin allow-presentation"
            title="Solgt.com video"
            className="w-full h-[192] md:h-[535]"
            src="https://www.youtube.com/embed/s9LGhd30a5w"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen={true}
          />
        </Box>
      </section>
      <div className="flex flex-col md:flex-row">
        <section id="map" className="md:w-1/2">
          <Box bleed>
            <header className="mb-24">
              <h3>Se forhandlere</h3>
            </header>
            <iframe
              sandbox="allow-scripts allow-same-origin"
              className="w-full h-[457]"
              title="Solgt.com forhandler kort"
              src="https://dba.solgt.com/forhandler-kort"
            />
          </Box>
        </section>
        <section id="help" className="md:mt-0 md:w-1/2">
          <Box bleed>
            <header className="mb-24">
              <h3>Brug for hjælp?</h3>
            </header>
            <p className="mb-16">
              Vi sidder klar ved telefonen alle hverdage kl. 9 - 16. Du er også meget velkommen til at skrive til os på
              mail.
            </p>
            <p className="mb-16">
              <a href="tel:+4561484545">61 48 45 45</a>
            </p>
            <p>
              <a href="mailto:support@solgt.com">Support@solgt.com</a>
            </p>
          </Box>
        </section>
      </div>
      <section id="byline" className="text-caption s-text-subtle">
        <Box bleed>
          <div className="mb-8">Præsenteres af</div>
          <div className="flex">
            <SolgtComLogo />
            &nbsp;og&nbsp;
            <DbaLogo />
          </div>
        </Box>
      </section>
    </div>
  );
};
